import React from 'react';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import ProgressBar from 'shared/ui/ProgressBar/ProgressBar';

import IBatchResult from '../../model/IBatchResult';

interface IExportResultProps {
    result: IBatchResult,
    countLabel: string,
    handleClose: () => void;
}

const ExportResult: React.FC<IExportResultProps> = ({result, countLabel, handleClose}) => {
    const url = result.payload.url;

    return <>
        <ModalBodyWrapper>
            <p className="text-medium">
                {countLabel}: {result.success_count}
            </p>
            {
                result.errors.length > 0
                && <div className="mt-2">
                    <p className="text-medium">{t`Ошибки`}:</p>
                    <ol>
                        {
                            result.errors.map((error, index) => <li
                                key={`${index}_${error}`}>
                                {error}
                            </li>)
                        }
                    </ol>
                </div>
            }
        </ModalBodyWrapper>
        <div className="mb-3">
            <ProgressBar percent={result.progress ?? 100}/>
        </div>
        <ModalBlockButton
            primaryButtonText={t`Скачать`}
            primaryButtonType="button"
            primaryButtonOnClick={() => window.open(url)}
            primaryButtonDisabled={!url}
            secondaryButtonOnClick={handleClose}
        />
    </>;
};

export default ExportResult;
